import { ReactNode } from "react";
import styled from "@emotion/styled";
import { MessageAuthor } from "../types";

const Bubble = styled.div<{ isHighlighted?: boolean }>`
  border-radius: ${({ theme }) => theme.roundness.md};
  padding: 0.5rem 0.5rem;
  max-width: 80%;
  word-break: break-word;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.text.primary.default};
`;

const BotBubble = styled(Bubble)`
  background: ${({ isHighlighted }) =>
    isHighlighted ? "yellow" : "transparent"};
  border: 0.0625rem;
  transform: ${({ isHighlighted }) =>
    isHighlighted ? "scale(1.1) translateX(6%)" : "scale(1) translateX(0)"};
  transition: transform 0.3s ease-in-out;
`;

const UserBubble = styled(Bubble)`
  background: ${({ theme, isHighlighted }) =>
    isHighlighted ? "yellow" : theme.colors.component.background[1]};
  border: 0.0625rem;
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? "yellow" : "transparent"};
  transform: ${({ isHighlighted }) =>
    isHighlighted ? "scale(1.1) translateX(-6%)" : "scale(1) translateX(0)"};
  transition: transform 0.3s ease-in-out;
`;

export type ChatBubbleProps = {
  author: MessageAuthor;
  isHighlighted?: boolean;
  children: ReactNode;
};

export const ChatBubble = ({
  children,
  isHighlighted = false,
  author,
}: ChatBubbleProps) =>
  author === MessageAuthor.Bot ? (
    <BotBubble data-testid="bot-bubble" isHighlighted={isHighlighted}>
      {children}
    </BotBubble>
  ) : (
    <UserBubble data-testid="user-bubble" isHighlighted={isHighlighted}>
      {children}
    </UserBubble>
  );
